import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-devversion-finalize-history',
  templateUrl: './fes-workflow-action-devversion-finalize-history.component.html',
  styleUrls: ['./fes-workflow-action-devversion-finalize-history.component.scss']
})
export class FesWorkflowActionDevversionFinalizeHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

}
